import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import { Link } from 'react-router-dom';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import {
  FaCheckCircle,
  FaChevronRight,
  FaCircle,
  FaStar,
} from 'react-icons/fa';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { PulseLoader } from 'react-spinners';
import * as actions from '../../actions';
import { summary, publishStore } from '../../queries';

import Loading from '../../components/Loading/Page';
import Footer from '../../components/Footer';

import { Content, ProgressBar } from './styles';
import { Breadcrumb, Wrapper } from '../../assets/styles';

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div className="custom-tooltip">
        <p className="month">{label}</p>
        <p className="value">{`Faturamento: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(payload[0].value)}`}</p>
      </div>
    );
  }

  return null;
};

const Steps = ({ item }) => (
  <div className="item">
    {item.status && <FaCheckCircle className="fa fa-check-circle" />}
    {!item.status && <i className="uncheck-circle" />}
    <p>{item.label}</p>
  </div>
);

class Home extends Component {
  state = {
    loading: false,
  }

  publishStore = () => {
    this.setState({ loading: true });

    this.props
      .publishStore({
        variables: { storeId: this.props.store.id },
        refetchQueries: [{ query: summary, variables: { storeId: this.props.store.id } }],
      })
      .then(async (res) => {
        this.setState({ loading: false });
        this.props.saveStore(res.data.publishStorePortal);
        this.props.alert.success('Sua loja está no ar! Boas vendas.');
      });
  }

  render() {
    const { loading, summaryPortal } = this.props.data;

    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Início - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <h2>Início</h2>
            <FaChevronRight className="fa fa-chevron-right" />
            <h2 className="bold">Visão geral</h2>
          </div>
        </Breadcrumb>
        <Wrapper>
          {loading && <Loading />}
          {!loading && (
            <Content>
              <div className="row chart">
                <div className="container">
                  <div className="head">
                    <h2>Resultados</h2>
                    <div style={{ display: 'flex' }}>
                      <FaCircle className="fa fa-circle" />
                      <span className="label">Faturamento</span>
                    </div>
                  </div>
                  <ResponsiveContainer width="100%">
                    <LineChart data={summaryPortal.billing}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" axisLine={false} tickLine={false} padding={{ left: 30, right: 30 }} tick={{ dy: 10 }} />
                      <YAxis axisLine={false} tickLine={false} type="number" tick={{ dx: -4 }} tickFormatter={tick => new Intl.NumberFormat('pt-BR').format(tick)} />
                      <Tooltip content={<CustomTooltip />} />
                      <Line type="monotone" name="Faturamento" dataKey="pv" stroke="#2FAA33" activeDot={{ r: 8 }} />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
              {!summaryPortal.status.published && (
              <div className="row">
                <div className="progress-container">
                  <h2>Seja bem-vindo</h2>
                  <p>Acompanhe o progresso da sua loja</p>
                  <div className="content">
                    {summaryPortal.status.progress === 100 && (
                      <div className="progress-complete">
                        <button type="submit" onClick={this.publishStore}>
                          {!this.state.loading ? (
                            <span>Publicar loja</span>
                          ) : (
                            <PulseLoader
                              sizeUnit="px"
                              size={7}
                              color="#FFFFFF"
                              loading
                            />
                          )}
                        </button>
                      </div>
                    )}
                    <div className={summaryPortal.status.progress === 100 ? 'in-progress' : ''}>
                      <ProgressBar percent={summaryPortal.status.progress}>
                        <div className="pecent-value">{`${summaryPortal.status.progress}%`}</div>
                        <div className="percentage" />
                      </ProgressBar>
                      <div className="steps">
                        {summaryPortal.status.steps.map((step, index) => (
                          <Steps
                            key={index.toString()}
                            item={step}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )}
              {summaryPortal.status.published && (
                <div className="row">
                  <div className="container">
                    <div className="content">
                      <h2>Valor da carteira</h2>
                      <h3>
                        <span>R$</span>
                        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(summaryPortal.balance.total).replace(/^(\D+)/, '')}
                      </h3>
                      <p>{`Dinheiro disponível: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(summaryPortal.balance.available)}`}</p>
                    </div>
                  </div>
                  <div className="container" style={{ marginTop: '30px' }}>
                    <div className="content">
                      <h2>Minhas avaliações</h2>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FaStar className="fa fa-star" />
                        <h3>{summaryPortal.totalRating === 0 ? 0 : parseFloat(summaryPortal.totalRating).toFixed(1).replace('.', ',')}</h3>
                      </div>
                      <p>Média geral</p>
                    </div>
                    <button type="submit">
                      <Link to="/dashboard/ratings" style={{ padding: '9px 17px' }}>
                        <span>Detalhes</span>
                      </Link>
                    </button>
                  </div>
                </div>
              )}
            </Content>
          )}
          <Footer />
        </Wrapper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store,
});

const mapDispathToProps = dispatch => bindActionCreators(actions, dispatch);

export default compose(
  connect(mapStateToProps, mapDispathToProps),
  withAlert(),
  graphql(publishStore, { name: 'publishStore' }),
  graphql(summary, {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: { storeId: props.store.id },
    }),
  }),
)(Home);
